"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARBITRUM_BRIDGE_SUPPORTED_CHAIN_IDS = void 0;
const types_1 = require("./types");
exports.ARBITRUM_BRIDGE_SUPPORTED_CHAIN_IDS = {
    sell: types_1.arbitrumBridgeSupportedChainIds,
    buy: types_1.arbitrumBridgeSupportedChainIds,
};
